<template>
<div class="chapter">
<div class="inner_page">
<h1 class="part-no" id="pt-1"><a id="page_1">The Letter <br/>to the <br/>COLOSSIANS</a><a id="page_2"></a></h1><a id="page_2">
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 009_Part01.vue?029213ee